<div class="loading-error">
  <div class="loading-error__content">
    <!-- Error Icon Container -->
    <div class="loading-error__icon-container">
      <div class="loading-error__icon">
        <!-- Error Icon using app-icon component -->
        <app-icon
          name="error"
          [size]="64"
          color="#96080B"
          class="loading-error__icon-svg">
        </app-icon>
      </div>
    </div>

    <!-- Text Content -->
    <div class="loading-error__text-section">
      <h2 class="loading-error__title">{{ titleKey() | translateLang }}</h2>
      <p class="loading-error__description">{{ descriptionKey() | translateLang }}</p>
    </div>

    <!-- Suggestions Box -->
    <div class="loading-error__suggestions">
      <p class="loading-error__suggestions-heading">{{ suggestionsHeadingKey() | translateLang }}</p>
      <div class="loading-error__suggestions-list">
        @for (suggestionKey of suggestionKeys(); track suggestionKey) {
          <div class="loading-error__suggestion-item">
            <div class="loading-error__bullet">
              <span class="loading-error__bullet-text">•</span>
            </div>
            <p class="loading-error__suggestion-text">{{ suggestionKey | translateLang }}</p>
          </div>
        }
      </div>
    </div>
 
    <!-- Action Buttons -->
    <div class="loading-error__actions">
      <button
        type="button"
        class="loading-error__button loading-error__button--primary"
        (click)="onRefresh()">
        {{ refreshButtonKey() | translateLang }}
      </button>
      <button
        type="button"
        class="loading-error__button loading-error__button--secondary"
        (click)="onContactSupport()">
        {{ contactButtonKey() | translateLang }}
      </button>
    </div>

    <!-- Reassurance Message -->
    <p class="loading-error__reassurance">{{ reassuranceKey() | translateLang }}</p>
  </div>
</div>
